import React from 'react';
import ContentImage from '../components/ContentImage';
import { Button } from '@mui/material';
import { Divider } from '@mui/material';

import * as styles from './Activities.module.css';

const ClosedExercise = ({
  lesson,
  contentfulId,
  userId,
  skipPhone,
  passingSearch,
  isMobile,
}) => {
  return (
    <li className={styles.containerSection}>
      {(lesson.closedExercise?.childMarkdownRemark?.html ||
        lesson?.closedExerciseImages) && (
        <>
          <h3 className={styles.subtitleH3Activities} id="multipla-escolha">
            1. Questão de múltipla escolha:
          </h3>
          <div className={styles.containerStart}>
            {lesson?.closedExerciseImages &&
              lesson?.closedExerciseImages.map((closedImage, index) => (
                <ContentImage
                  contentfulId={contentfulId}
                  userId={userId}
                  key={'closedExerciseImages' + index}
                  value={closedImage}
                  lesson={lesson}
                  urlSlug="multipla-escolha"
                />
              ))}
          </div>
          {lesson.closedExercise?.childMarkdownRemark?.html && (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  lesson.closedExercise?.childMarkdownRemark?.html.replaceAll(
                    '\n',
                    '</p><p>'
                  ),
              }}
            />
          )}
          {lesson.closedExerciseOptions?.childMarkdownRemark?.html && (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  '<strong>' +
                  lesson.closedExerciseOptions?.childMarkdownRemark?.html
                    .replaceAll('\n', '</p><p><strong>')
                    .replaceAll(')', ')</strong>'),
              }}
            />
          )}

          <Button
            href={`${process.env.GATSBY_APP_BASE_URL}/aula/${contentfulId}/multipla-escolha?utm_origin=SEO&SEOID=${userId}${skipPhone}${passingSearch}`}
            className="contained-btn btn-medium"
            style={{ marginTop: isMobile ? '20px' : '14px' }}
          >
            Atividade completa
          </Button>
        </>
      )}
      <Divider className="divider" />
    </li>
  );
};

export default ClosedExercise;
